import { colors } from './Theme';

export const colorPallete = {
  surface: {
    primary: colors.white,
    secondary: colors.gray[50],
    tertiary: colors.gray[100],
    background: {
      primary: colors.gray[50],
      secondary: colors.gray[100],
    },
    disable: colors.gray[50],
    disabled: colors.gray[50],
    inverse: {
      primary: colors.black,
      secondary: colors.gray[700],
    },
    accent: colors.blue[400],
    negative: colors.red[400],
    warning: colors.yellow[400],
    positive: colors.green[400],
    accentLight: colors.blue[50],
    negativeLight: colors.red[50],
    warningLight: colors.yellow[50],
    positiveLight: colors.green[50],
    overlay: {
      dark: '#0000004D',
      light: '#0000001F',
    },
  },
  content: {
    primary: colors.black,
    secondary: colors.gray[600],
    tertiary: colors.gray[500],
    disabled: colors.gray[400],
    onInverse: colors.white,
    accent: colors.blue[400],
    negative: colors.red[400],
    warning: colors.yellow[400],
    positive: colors.green[400],
    onBrand: colors.white,
    onAccent: colors.white,
    onNegative: colors.white,
    onWarning: colors.black,
    onPositive: colors.white,
  },
  border: {
    primary: colors.gray[200],
    inversePrimary: colors.gray[700],
    selected: colors.gray[700],
    focus: colors.gray[700],
    accent: colors.blue[200],
    negative: colors.red[200],
    warning: colors.yellow[200],
    positive: colors.green[200],
  },
  brand: {
    tapsi: colors.orange[400],
  },
};
